<template>
  <div style="height: 100%;">
    <el-table :data="simData" style="width: 100%" border class="simTable">
      <el-table-column prop="name1" :label="$t('allDeviceDetail.Attributes')" align="center" class="simLabel" />
      <el-table-column prop="value1" :label="$t('allDeviceDetail.Value')" align="center" />
      <el-table-column prop="name2" :label="$t('allDeviceDetail.Attributes')" align="center" class="simLabel" />
      <el-table-column prop="value2" :label="$t('allDeviceDetail.Value')" align="center" />
    </el-table>
  </div>
</template>

<script>

import { getDateAndHour } from '@/utils/updateTime.js'
import { getSim263TableByMcuId } from '@/api/allDevice'
import i18n from '@/i18n'

export default {
  components: {
  },
  props: {
    mcuId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      simData: []
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
    }
  },
  mounted() {
    setTimeout(() => {
      this.queryList()
    }, 50)
  },
  methods: {
    queryList() {
      if (this.mcuId) {
        getSim263TableByMcuId({ mcuId: this.mcuId }).then(res => {
          if (res.resultCode == 1001) {
            if (res.resultModel) {
              var obj = res.resultModel
              if (!obj.realFlow && obj.realFlow != 0) {
                obj.realFlowZh = '--'
              } else if ((obj.realFlow / 1024).toFixed(2) == 0) {
                obj.realFlowZh = obj.realFlow + 'KB'
              } else {
                obj.realFlowZh = (obj.realFlow / 1024).toFixed(2) + ' M'
              }
              if (!obj.tcFlow && obj.tcFlow != 0) {
                obj.tcFlowZh = '--'
              } else if ((obj.tcFlow / 1024).toFixed(2) == 0) {
                obj.tcFlowZh = obj.tcFlow + 'KB'
              } else {
                obj.tcFlowZh = (obj.tcFlow / 1024).toFixed(2) + ' M'
              }
              if (!obj.exceedFlow && obj.exceedFlow != 0) {
                obj.exceedFlowZh = '--'
                obj.flowStatu = i18n.t('allDeviceDetail.ReFlow')// '当月剩余流量'
              } else if (obj.exceedFlow <= 0) {
                obj.flowStatu = i18n.t('allDeviceDetail.ReFlow')// '当月剩余流量'
                if ((obj.exceedFlow / 1024).toFixed(2) == 0) {
                  obj.exceedFlowZh = -obj.exceedFlow + 'KB'
                } else {
                  obj.exceedFlowZh = (-obj.exceedFlow / 1024).toFixed(2) + ' M'
                }
              } else {
                obj.flowStatu = i18n.t('allDeviceDetail.exFlow')// '当月超出流量'
                if ((obj.exceedFlow / 1024).toFixed(2) == 0) {
                  obj.exceedFlowZh = obj.exceedFlow + 'KB'
                } else {
                  obj.exceedFlowZh = (obj.exceedFlow / 1024).toFixed(2) + ' M'
                }
              }
              var activeTime = obj.activeTime ? getDateAndHour(obj.activeTime, 'noTime') : '--'
              var expireTime = obj.expireTime ? getDateAndHour(obj.expireTime, 'noTime') : '--'
              var tcUpdateTime = obj.tcUpdateTime ? getDateAndHour(obj.tcUpdateTime, 'noTime') : '--'
              var giveMonthZh, renewMonthZh
              if (obj.giveMonth || obj.giveMonth == 0) {
                giveMonthZh = obj.giveMonth > 1 ? obj.giveMonth + i18n.t('allDeviceDetail.months') : obj.giveMonth + i18n.t('allDeviceDetail.month')
              } else {
                giveMonthZh = '--'
              }
              if (obj.renewMonth || obj.renewMonth == 0) {
                renewMonthZh = obj.renewMonth > 1 ? obj.renewMonth + i18n.t('allDeviceDetail.months') : obj.renewMonth + i18n.t('allDeviceDetail.month')
              } else {
                renewMonthZh = '--'
              }
              this.simData = []
              this.simData.push(
                /* '激活时间' '套餐更新时间'
                 * '过期时间' '套餐流量'
                 * '赠送月数' '实际使用流量'
                 * '续费月数'  当月剩余流量
                */
                { name1: i18n.t('allDeviceDetail.ActivationTime'), key1: 'activeTime', value1: activeTime, name2: i18n.t('allDeviceDetail.UpdateTime'), key2: 'tcUpdateTime', value2: tcUpdateTime },
                { name1: i18n.t('allDeviceDetail.Expiration'), key1: 'expireTime', value1: expireTime, name2: i18n.t('allDeviceDetail.PackageFlow'), key2: 'tcFlow', value2: obj.tcFlowZh },
                { name1: i18n.t('allDeviceDetail.GiveMonth'), key1: 'giveMonth', value1: giveMonthZh, name2: i18n.t('allDeviceDetail.realFlow'), key2: 'realFlow', value2: obj.realFlowZh },
                { name1: i18n.t('allDeviceDetail.RenewalMonth'), key1: 'renewMonth', value1: renewMonthZh, name2: obj.flowStatu, key2: 'exceedFlow', value2: obj.exceedFlowZh },
              )
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
p{
  margin:0
}
.simTable{
  th:nth-of-type(odd),td:nth-of-type(odd){
    background: #f0f2f591;
  }
}
</style>

